<template>
  <div class="isStylePageContent isPaddingBottom">
    <div :class="$style.inventoryItemDetail">
      <div class="detail-image">
        <img v-if="inventoryItemDetailData.image" :src="inventoryItemDetailData.image" />
        <img v-else :src="require(`@assets/images/icons/face-cream.svg`)" />
        <p class="title">{{ inventoryItemDetailData.title }}</p>
        <p class="sub-title">{{ inventoryItemDetailData.petCategoryTitle }}</p>
      </div>
      <DetailTable ref="detailTable" :spec-list="specList" style="width:80%;"></DetailTable>
    </div>
    <div :class="$style.footer">
      <el-button class="is-round" @click="$emit('goCategory')">返回列表</el-button>
      <el-button :disabled="!haveSelectedInventory" class="is-round" type="primary"
        @click="updateInventoryList">加入商品</el-button>
    </div>
  </div>
</template>

<script>
import DetailTable from './DetailTable.vue'

export default {
  name: 'InventoryItemDetail',
  components: { DetailTable },
  props: {
    inventoryItemDetailData: {
      type: Object,
      required: true,
      default: () => {
        return {}
      },
    },
    /**
     * @description 使用者選擇的出貨進貨點
     */
    userSelectedShippingPoint: {
      type: String,
      default: ''
    }
  },
  data() {
    return { isMounted: false }
  },
  computed: {
    // 多塞商品名稱、商品分類給表單用
    specList() {
      const result = this.inventoryItemDetailData.petSizes.reduce((accu, cur) => {
        // 如果使用者沒點選進貨出貨點 or 廠商走這邊
        if (this.userSelectedShippingPoint === '' || this.userSelectedShippingPoint === 'manufacturer') {
          this.$set(cur, 'inventory', 0)
          accu.push({ ...cur, title: this.inventoryItemDetailData.title, petCategoryTitle: this.inventoryItemDetailData.petCategoryTitle })
          return accu
        }
        // 如果使用者點選店家走這邊
        if (this.userSelectedShippingPoint !== '' && this.userSelectedShippingPoint.length > 0 &&
          cur.productId !== this.userSelectedShippingPoint && this.userSelectedShippingPoint !== 'manufacturer') {
          const selectProductPetSize = this.inventoryItemDetailData.petSizes.find(item => item.spec_tag === cur.spec_tag && item.productId === this.userSelectedShippingPoint)
          this.$set(cur, 'inventory', selectProductPetSize?.inventory || 0)
          accu.push({ ...cur, title: this.inventoryItemDetailData.title, petCategoryTitle: this.inventoryItemDetailData.petCategoryTitle })
          return accu
        }
        return accu
      }, [])
      return result
    },
    haveSelectedInventory() {
      if (this.isMounted) {
        return this.$refs.detailTable.selectedInventories.length > 0
      } else return false
    },
  },
  mounted() {
    this.isMounted = true
  },
  methods: {
    updateInventoryList() {
      this.$refs.detailTable.updateInventoryList()
      this.$emit('goCategory')
    },
  },
}
</script>

<style lang="scss" module>
.inventoryItemDetail {
  display: flex;
  gap: 20px;

  :global {
    .detail-image {
      width: 190px;
      flex-basis: 190px;

      p {
        margin: 10px;
      }

      img {
        width: 190px;
      }

      .title {
        color: #121931;
        font-size: 16px;
      }

      .sub-title {
        color: #6c6b6b;
        font-size: 12px;
      }
    }
  }
}

.footer {
  padding: 20px 40px;
  width: calc(100% - 72px);
  position: fixed;
  left: 72px;
  bottom: 0;
  display: flex;
  gap: 10px;
  box-shadow: 3px -3px 10px #00000019;
  background-color: #fff;
  z-index: 2;

  :global {
    button {
      flex: 1;
    }
  }
}
</style>
